// extracted by mini-css-extract-plugin
module.exports = {"timesDesc":"index_timesDesc__T_QXX","item":"index_item__BaKBy"};